
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yolo/[network]/history",
      function () {
        return require("private-next-pages/yolo/[network]/history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/yolo/[network]/history"])
      });
    }
  